import { BusAuthorizedStatus, IMechanicalInformation } from '@/types/mechanicalInformation'

export const checkIfMechanicalInformationIsSubmitted = (info: IMechanicalInformation): boolean => {
    if (!info.busAuthorizedStatus) {
        return false
    }

    if (info.busAuthorizedStatus === BusAuthorizedStatus.BusAuthorized) {
        return !!info.timeCleared
    }

    return !!info.subbedBonnetNumber && !!info.substitutionTime
}
